const iconAccessibility = (accessibilityLabel?: string) => {
  if (accessibilityLabel != null) {
    return { 'aria-label': accessibilityLabel, role: 'img' };
  }
  return {
    'aria-hidden': true,
    role: 'presentation',
  };
};

export default iconAccessibility;
